<section>
  <div class="dialog-box">
    <div class="dialog-header">
      <p class="heading">{{'ADD_TEXT'|translate}} {{searchType|translate}}</p>
      <mat-icon aria-hidden="false" fontIcon="close" class="icon" (click)="closeDialog()"></mat-icon>
    </div>

    <div class="dialog-body">
      <mat-radio-group aria-label="Select an option" class="radio-display">
        <mat-radio-button value="1" [checked]="true" (change)="changeSelection($event)">{{'RANGE_SELECTION' | translate }}</mat-radio-button>
        <mat-radio-button value="2" (change)="changeSelection($event)">{{'MULTIPLE_SELECTION' | translate }}</mat-radio-button>
      </mat-radio-group>

      <div *ngIf="isMultiple">
        <div class="input-bar">
          <div class="input-cell">
            <p class="label">{{'FROM' | translate }}:</p>
            <input [formControl]="fromValue" />
          </div>
          <div class="input-cell">
            <p class="label">{{'TO' | translate }}:</p>
            <input [formControl]="toValue" />
          </div>
          <button class="add-btn" (click)="addRangeRow()">
            <mat-icon aria-hidden="false" fontIcon="add_box" class="icon"></mat-icon>
          </button>
        </div>
        <div class="data-list">
          <div class="header-flex">
            <div class="data-cell-25">{{'FROM' | translate }}</div>
            <div class="data-cell-25">{{'TO' | translate }}</div>
            <div class="data-cell-20"></div>
          </div>
          <div *ngFor="let rowValue of rangeValues">
            <div class="header-flex">
              <div class="data-cell-25">{{ rowValue.from }}</div>
              <div class="data-cell-25">{{ rowValue.to }}</div>
              <mat-icon aria-hidden="false" fontIcon="delete_forever" class="icon data-cell-20"
                (click)="removeRowValueById(rowValue.id)"></mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isAdd">
        <div class="input-bar" [ngStyle]="{justifyContent:'center'}">
          <div class="input-cell">
            <p class="label">{{searchType | translate}}:</p>
            <input [formControl]="invoice" [maxLength]="maxLength"/>
          </div>
          <button class="add-btn" (click)="addMultipleRow()">
            <mat-icon aria-hidden="false" fontIcon="add_box" class="icon"></mat-icon>
          </button>
        </div>
        <div class="data-list">
          <div *ngFor="let rowValue of multiValues">
            <div class="header-flex" [ngStyle]="{justifyContent:'center', marginLeft:'6rem'}">
              <div class="data-cell-25">{{ rowValue.invoice }}</div>
              <mat-icon aria-hidden="false" fontIcon="delete_forever" class="icon data-cell-20"
                (click)="removeMultiValueById(rowValue.id)"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button class="dialog-footer-btn blue-btn" (click)="closeDialogWithData()">
        Ok
      </button>
      <button class="dialog-footer-btn white-btn" (click)="closeDialog()">
        {{'CLOSE_TEXT' | translate }}
      </button>
    </div>
  </div>
</section>